// ============================================================
// Platform Control · Legal — terms, policies, and DPA links.
// Distinct from Audit Logs: this view owns documents, not events.
// ============================================================

import ViewShell, { Card, Section } from './_ViewShell'
import { SHELL_TOKENS } from '../../../shell/styles'

const DOCS: { id: string; label: string; status: string }[] = [
  { id: 'tos',     label: 'Terms of Service',          status: 'draft' },
  { id: 'privacy', label: 'Privacy Policy',            status: 'draft' },
  { id: 'dpa',     label: 'Data Processing Agreement', status: 'not yet drafted' },
  { id: 'sub',     label: 'Subprocessor List',         status: 'not yet drafted' },
]

export default function LegalView() {
  return (
    <ViewShell
      kicker="PLATFORM CONTROL · LEGAL"
      title="Legal"
      description="Terms, policies, and DPA documents. Not stored in the audit trail — these are documents, not events."
    >
      <Section label="DOCUMENTS">
        <Card>
          {DOCS.map((d, i) => (
            <div
              key={d.id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 0',
                borderBottom:
                  i === DOCS.length - 1
                    ? 'none'
                    : `1px solid ${SHELL_TOKENS.border}`,
              }}
            >
              <div style={{ fontSize: 12, color: SHELL_TOKENS.ink, fontWeight: 600 }}>
                {d.label}
              </div>
              <div
                style={{
                  fontSize: 10,
                  color: SHELL_TOKENS.inkMuted,
                  fontFamily: 'var(--font-mono)',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                }}
              >
                {d.status}
              </div>
            </div>
          ))}
        </Card>
      </Section>
    </ViewShell>
  )
}
